import { FC } from 'react';
import { CalendarEventAttendee } from '@demind-inc/core';
import { mdiAccountGroup } from '@mdi/js';
import Icon from '@mdi/react';
import { Avatar, Tooltip } from '@mui/material';
import { upperFirst } from 'lodash';

import './EventAttendees.scss';
import { useTranslation } from 'react-i18next';

interface EventAttendeesProps {
  attendees: CalendarEventAttendee[];
  className?: string;
}

const EventAttendees: FC<EventAttendeesProps> = ({ attendees, className }) => {
  const { t } = useTranslation();
  const acceptedCount = attendees.filter((a) => a.responseStatus === 'accepted').length;
  const summary = [
    t('calendar.eventMenu.guests', { count: attendees.length }),
    acceptedCount > 0 ? t('calendar.eventMenu.acceptedCount', { count: acceptedCount }) : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className={`event-attendees${className ? ` ${className}` : ''}`}>
      <Icon path={mdiAccountGroup} className="event-attendees__icon" />
      <div className="event-attendees__content">
        <div className="event-attendees__summary">{summary}</div>
        <div className="event-attendees__avatars">
          {attendees.slice(0, 5).map((attendee) => {
            const statusLabel = t(
              `calendar.invite.status.${attendee.responseStatus || 'needsAction'}`,
              { defaultValue: t('calendar.invite.status.pending') }
            );
            const tooltipTitle = (
              <div className="event-attendees__tooltip">
                <span className="event-attendees__tooltip__email">{attendee.email}</span>
                <span className="event-attendees__tooltip__status">{statusLabel}</span>
              </div>
            );

            return (
              <Tooltip key={attendee.email} title={tooltipTitle} placement="top" arrow>
                <Avatar className="event-attendees__avatars__item">
                  {upperFirst(attendee.email.charAt(0))}
                </Avatar>
              </Tooltip>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EventAttendees;
